import { Dashboard } from 'ui/components/buyer/patterns/Dashboard/Dashboard';

/**
 * 買い手企業ダッシュボード
 */
export const BuyerDashboard: React.FC = () => {
    return <Dashboard />;
};
